import Link from "next/link";

import Image from "@/components/Image";

function AlbumReviewThumbnail({ artist, cover, genre, newbin, title, url, i }) {
  return (
    <div className="thumbnail mb-3">
      <Link href={url}>

        <Image
          src={cover}
          width={500}
          height={500}
          alt={`${title} by ${artist}`}
          priority={i < 8}
        />
        <div className="text-center">
          <p
            className="text-uppercase"
            style={{
              fontSize: "16pt",
            }}
          >
            <b>
              <i>{title}</i>
            </b>
          </p>
          <p>{artist}</p>
          <p className="text-uppercase">
            <small>
              <b>{genre.split(" - ")[0]}</b>
            </small>
          </p>
        </div>

      </Link>
    </div>
  );
}

export default AlbumReviewThumbnail;
